import {ConfigObjectType, useApiQuery} from '@wallaby-ui/core';
import {HaidiSchema, MerieSchema} from 'src/js/common/types';

export type RawDocumentData = HaidiSchema.components['schemas']['DocumentViewDto'] & MerieSchema.components['schemas']['DocumentViewDto'];
export interface UseLoadDocumentReturnValue {
  rawDocumentData: RawDocumentData | undefined;
  isLoading: boolean;
  isError: boolean;
}

export interface UseLoadDocumentParams {
  encounterId?: string;
  documentId?: string;
  config: ConfigObjectType;
  isHaidi?: boolean;
}

export function useLoadDocument({documentId, encounterId, config, isHaidi}: UseLoadDocumentParams): UseLoadDocumentReturnValue {
  const apiUrl = isHaidi
    ? config.service.url.document.replace(`{documentId}`, documentId ?? '')
    : `${config.service.url.hospitalizationDetail}/${encounterId}/${config.service.url.hospitalizationDetailDocumentVersionMethod}/${documentId}`;
  const {data, isLoading, isError} = useApiQuery<RawDocumentData>([apiUrl], null, {
    axiosConfig: {
      url: apiUrl,
    },
    reactQueryOptions: {
      enabled: Boolean(documentId),
    },
  });

  return {
    rawDocumentData: data,
    isLoading,
    isError,
  };
}
